import { render, staticRenderFns } from "./EventTable.vue?vue&type=template&id=613a502a"
import script from "./EventTable.vue?vue&type=script&lang=js"
export * from "./EventTable.vue?vue&type=script&lang=js"
import style0 from "./EventTable.vue?vue&type=style&index=0&id=613a502a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports